import React from 'react'
import styled from 'styled-components'

interface Props {
  orientation?: 'vertical' | 'horizontal'
  /**
   * How long should the line be with regards to container's side?
   * 
   * Use CSS units.
   * 
   * Default:  100%.
   */
  fillAmount?: string | number
  /**
   * How tall should the line be?
   * 
   * Use CSS units.
   * 
   * Default:  1px.
   */
  length?: string | number
  margin?: string
  color?: string
}

/**
 * Defaults to being a '100%' width horizontal line of '1px' height
 */
const SepLine = ({
  orientation,
  fillAmount='100%',
  length='1px',
  margin,
  color,
}: Props) => {
  const isVertical = orientation == 'vertical'

  return (
    <Base style={{
      ...(isVertical ? {
        width: length,
        height: fillAmount,
      } : {
        width: fillAmount,
        height: length,
      }),
      margin,
      backgroundColor: color,
    }} />
  )
}

export default SepLine

const Base = styled.div`
  background-color: var(--gray-c2);
`
